export const CRoutesWithParametersList = {
  ticketsGiftCard: '/account-tickets/giftCard/',
  ticketsMembership: '/account-tickets/membership/',
  ticketsBooking: '/account-tickets/booking/'
};

/** List of routes */
export const CRouteList = {
  maintenance: '/maintenance',
  error: '/error',
  errorStorage: '/error-storage',
  redirect: '/redirect',
  lost: '/404',

  home: '/home',

  products: '/products',
  productMemberships: '/products/memberships',
  productPage: '/product/',

  addon: '/checkout/addons',
  details: '/checkout/details',
  agreement: '/checkout/agreement',
  payment: '/checkout/payment',
  confirmation: '/checkout/confirmation',
  waiver: '/checkout/waiver',
  waiverShare: '/checkout/waiver-share',

  login: '/login',
  signup: '/signup',
  signOut: '/signout',
  verifyEmail: '/verify-email',
  rsvp: '/rsvp',
  rsvpDetails: '/details-form',
  rsvpSent: '/sent',

  account: '/account',
  accountDetails: '/account/details',
  accountPayments: '/account/payments',
  tickets: '/account-tickets',

  // routes with route parameters
  ...CRoutesWithParametersList
};

export const CAccountPageRoutes = {
  details: 'details',
  payments: 'payments'
};

export const CAccountChildRoutes = [
  '/account/details',
  '/account/payments',
  '/account-tickets/membership',
  '/account-tickets/booking',
  '/account-tickets/giftCard'
];

export enum ERouteList {
  home = 1,
  products,
  addons,
  details,
  agreement,
  payment,
  confirmation
}

export const CQueryParamList = {
  isSignUp: 'isSignUp'
};
